import Cookies from 'js-cookie';
import {
  ACCESS_TOKEN_KEY,
  CSRF_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  SECRET_TOKEN,
  USER_TOKEN,
} from '@/src/shared/constants/cookie';

export const tokenService = {
  setRefreshToken(token: string) {
    Cookies.set(REFRESH_TOKEN_KEY, token, {
      sameSite: 'strict',
      path: '/',
      expires: 7,
    });
  },
  getRefreshToken() {
    return Cookies.get(REFRESH_TOKEN_KEY) || null;
  },
  setAccessToken(token: string) {
    Cookies.set(ACCESS_TOKEN_KEY, token, {
      sameSite: 'strict',
      path: '/',
      expires: 7,
    });
  },
  getAccessToken() {
    return Cookies.get(ACCESS_TOKEN_KEY) || null;
  },
  setCSRFToken(token: string) {
    Cookies.set(CSRF_TOKEN_KEY, token, {
      sameSite: 'strict',
      path: '/',
      expires: 7,
    });
  },
  getCSRFToken() {
    return Cookies.get(CSRF_TOKEN_KEY) || null;
  },
  setSecretToken(token: string) {
    Cookies.set(SECRET_TOKEN, token, { sameSite: 'strict', path: '/' });
  },
  getSecretToken() {
    return Cookies.get(SECRET_TOKEN) || null;
  },
  setUserToken(token: string) {
    Cookies.set(USER_TOKEN, token, { sameSite: 'strict', path: '/' });
  },
  getUserToken() {
    return Cookies.get(USER_TOKEN) || null;
  },
  clearTokens() {
    Cookies.remove(REFRESH_TOKEN_KEY, { path: '/' });
    Cookies.remove(CSRF_TOKEN_KEY, { path: '/' });
    Cookies.remove(ACCESS_TOKEN_KEY, { path: '/' });
    Cookies.remove(SECRET_TOKEN, { path: '/' });
    Cookies.remove(USER_TOKEN, { path: '/' });
  },
};
